import { IFloodgateFeatureStatusCallback } from "@ms-ofb/floodgate-shared-typings";
import { safeParseObject } from "@ms-ofb/officefloodgatecore/dist/src/Utils";
import { readFeatureGateOverridesFromCache } from "../Configuration/ReadCacheOverrides";

export default class FeatureGateProvider implements IFloodgateFeatureStatusCallback {
	// Calback for retrieving feature gate values from host app to enable experimental features 
	private featureStatusCallback?: IFloodgateFeatureStatusCallback;

	constructor(featureStatusCallback?: IFloodgateFeatureStatusCallback) {
		this.featureStatusCallback = featureStatusCallback ?? null;
	}

	public getStringFeatureStatus(featureGateName: string, defaultValue = ""): string {
		if (!this.featureStatusCallback) {
			return defaultValue;
		}

		try {
			const cacheOverride = readFeatureGateOverridesFromCache(featureGateName);
			if (cacheOverride) {
				return cacheOverride.toString();
			}
			return this.featureStatusCallback.getStringFeatureStatus(featureGateName, defaultValue);
		} catch {
			return defaultValue
		}
	}

	public getIntFeatureStatus(featureGateName: string, defaultValue = 0): number {
		if (!this.featureStatusCallback) {
			return defaultValue;
		}

		try {
			const cacheOverride = readFeatureGateOverridesFromCache(featureGateName);
			if (cacheOverride) {
				return parseInt(cacheOverride.toString());
			}
			return this.featureStatusCallback.getIntFeatureStatus(featureGateName, defaultValue);
		} catch {
			return defaultValue
		}
	}

	public getBoolFeatureStatus(featureGateName: string, defaultValue = false): boolean {
		if (!this.featureStatusCallback) {
			return defaultValue;
		}
		
		try {
			const cacheOverride = readFeatureGateOverridesFromCache(featureGateName);
			if (cacheOverride) {
				return cacheOverride.toString() === "true";
			}
			return this.featureStatusCallback.getBoolFeatureStatus(featureGateName, defaultValue);
		} catch {
			return defaultValue
		}
	}

	public getJsonObjectStringFeatureStatus<T>(featureGateName: string, defaultValue: T = null): T {
		if (!this.featureStatusCallback) {
			return defaultValue;
		}

		try {
			const overrideValue = this.getStringFeatureStatus(featureGateName, "");
			if (!overrideValue) {
				return defaultValue;
			}

			return safeParseObject(overrideValue, defaultValue);
		} catch {
			return defaultValue
		}
	}
}